import { object, string, array, number } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  evt_id: string().required(),
  session_id: string().required(),
  heartbeat_interval: number().required(),
  init_subs: array().of(string().required()).required(),
  server_time: number().required(),
});

/**
 * SystemHelloEvent
 *
 * - Esse evento é enviado pelo servidor imediatamente após o cliente se conectar.
 */
export class SystemHelloEvent extends CreateCommand(RealtimeEventType.SystemHello, SCHEMA) {}
